/**
 * Wrapper for the team route tree — daily operations over the AI team
 * (overview, questions, reviews, reports, email trust). System
 * administration lives under /admin. Gated by `AdminGate`; a future
 * `team-operator` role slots into that gate, not here.
 */
import { Outlet } from "react-router-dom";

import { AdminGate } from "../../components/AdminGate";
import { SubNav } from "../../components/SubNav";
import { useTeamStatus } from "../../hooks/useTeamStatus";
import { teamSections } from "../../lib/aiTeam";

export function TeamLayout() {
  return (
    <AdminGate>
      <div className="page">
        <TeamSubNav />
        <Outlet />
      </div>
    </AdminGate>
  );
}

/** Rendered inside the gate, so the admin-only counts load only for admins. */
function TeamSubNav() {
  const { counts } = useTeamStatus();
  return <SubNav ariaLabel="Team sections" items={teamSections(counts)} />;
}
